module.exports = __webpack_public_path__ + "static/media/Slider2.97ba5560.jpg";